import RankingsModal from './RankingsModal';

export default RankingsModal;